<template>
  <div class="gov-course-list">
    <!-- 顶部背景 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <!-- <div class="top-banner-center">
          <div
            class="wow animate__animated animate__zoomIn banner-btn"
            @click="onClickLookMore"
          >
            服务咨询
          </div>
        </div>-->
      </div>
    </div>
    <div class="top-header-box">
      <div class="top-header-img">
        <div class="top-search">
          <el-input
            placeholder="请输入内容"
            v-model="searchMsg"
            @keyup.native.enter="getServiceList"
            ref="search"
          >
            <template slot="append">
              <div class="top-search-icon" @click="getServiceList"></div>
            </template>
          </el-input>
        </div>
      </div>
    </div>
    <div class="key-words">
      <!-- <div class="half-radius"></div> -->
      <div class="flex type-wrap type-wrap1">
        <div style="margin-left: 20px;">服务分类：</div>
        <div class="type">
          <div
            v-show="serviceTypeList.length > 0"
            class="words-width"
            @click="clickType('')"
            :class="typeUuid == '' ? 'cur' : ''"
          >全部</div>
          <div style="display:flex;flex-flow:row wrap">
            <div
              v-for="item in serviceTypeList"
              :key="item.uuid"
              class="words-width"
              @click="clickType(item.uuid)"
              :class="typeUuid == item.uuid ? 'cur' : ''"
            >
              <div>{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="childTypeList flex" v-show="typeChildList.length > 0">
        <div
          v-for="item in typeChildList"
          :key="item.uuid"
          class="words-width mr0"
          @click="clickTypeChild(item.uuid)"
          :class="typeChildUuid == item.uuid ? 'cur' : ''"
        >
          <div>{{ item.title }}</div>
        </div>
      </div>
      <div class="flex type-wrap type-wrap2">
        <div style="margin-left:20px;">服务能力：</div>
        <div class="type">
          <div
            v-show="serviceAbilityList.length > 0"
            class="sort-rules-com"
            @click="clickAblity('')"
            :class="ablityUuid == '' ? 'cur' : ''"
          >全部</div>
          <div style="display:flex;flex-flow:row wrap">
            <div
              class="sort-rules-com"
              v-for="item in serviceAbilityList"
              :key="item.uuid"
              @click="clickAblity(item.uuid)"
              :class="ablityUuid == item.uuid ? 'cur' : ''"
            >{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="gov-course">
        <div class="empty" v-show="dataList.length == 0">暂无数据</div>
        <el-row>
          <div v-for="(item, index) in dataList" :key="index" @click="onClickDetail(item)">
            <el-col :span="6" class="course-list-item-box">
              <div class="item-out-box">
                <div class="pic-out-box">
                  <div class="course-list-img" :style="{ backgroundImage: `url(${item.pic})` }"></div>
                </div>
                <div class="content-title">{{ item.title }}</div>
                <div class="content-cases">典型案例：{{ item.cases }}</div>
                <div class="content-link-method">联 系 人：{{ item.linkMethod }}</div>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
      <div style="text-align: center;padding: 30px 0;">
        <el-pagination
          @current-change="onChangeCurrent"
          :current-page="params.current"
          :page-size="params.pageSize"
          background
          layout="prev, pager, next"
          :total="params.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDictionaryItem,
  getServicePageList,
  getServiceAbilityList,
  getServiceTypeList
} from "../../utils/interface";
export default {
  data() {
    return {
      headerBgUrl: "",
      searchMsg: "",

      params: {
        current: 1,
        pageSize: 16,
        total: 0,
        stage: ""
      },
      serachInWords: "",
      serviceTypeList: [],

      priceArangeStart: "",
      priceArangeEnd: "",

      dataList: [],

      serviceAbilityList: [],

      searchWordsData: [
        { name: "基础知识" },
        { name: "金属成型" },
        { name: "机械加工" },
        { name: "水泵装配" },
        { name: "水泵测试" }
      ],
      typeChildList: [], // 服务分类子类list
      typeUuid: "", // 服务分类uuid
      typeChildUuid: "", // 服务分类的子类uuid
      ablityUuid: "", // 服务能力uuid
      timer: null
    };
  },
  async created() {
    await this.getServiceTypeList();
    await this.getServiceAbilityList();
    this.getOptionsData();
    this.getServiceList(); // 默认展示全部服务分类和全部服务能力的信息
  },
  mounted() {
    if (this.$route.query.title) {
      this.searchMsg = this.$route.query.title;
      this.$refs.search.focus();
      this.getServiceList();
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: 420,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    // 获取服务商分类列表
    getServiceTypeList() {
      return new Promise((resolve, reject) => {
        getServiceTypeList().then(res => {
          if (res && res.length > 0) {
            this.serviceTypeList = res;
            resolve();
          } else {
            this.serviceTypeList = [];
            reject();
          }
        });
      });
    },
    // 获取服务商能力列表
    getServiceAbilityList() {
      return new Promise((resolve, reject) => {
        getServiceAbilityList().then(res => {
          if (res && res.length > 0) {
            this.serviceAbilityList = res;
            resolve();
            // console.log("服务商能力:", res)
          } else {
            this.serviceAbilityList = [];
            reject();
          }
        });
      });
    },
    clickType(uuid) {
      this.typeUuid = uuid;
      if (uuid) {
        let i = this.serviceTypeList.findIndex(el => {
          return el.uuid == uuid;
        });
        this.typeChildList = this.serviceTypeList[i].children
          ? this.serviceTypeList[i].children
          : [];
        this.typeChildUuid =
          this.typeChildList.length > 0 ? this.typeChildList[0].uuid : "";
      } else {
        this.typeChildList = [];
        this.typeChildUuid = "";
      }
      this.getServiceList();
    },
    clickTypeChild(uuid) {
      this.typeChildUuid = uuid;
      this.getServiceList();
    },
    clickAblity(uuid) {
      this.ablityUuid = uuid;
      this.getServiceList();
    },
    // 获取服务商列表
    getServiceList() {
      getServicePageList({
        status: 1,
        rec: 1,
        current: this.params.current,
        pageSize: 16,
        programUuid: this.typeUuid,
        title: this.searchMsg,
        programChildUuid: this.typeChildUuid || "",
        capabilityUuid: this.ablityUuid
      }).then(res => {
        if (res.list && res.list.length > 0) {
          let result = [];
          res.list.forEach(ele => {
            if (ele.caseList) {
              if (ele.caseList.length > 0) {
                ele.caseList.forEach(o => {
                  result.push(o.title);
                });
                ele["cases"] = result.toString().replace(",", "、");
              } else {
                ele["cases"] = "";
              }
            }
          });
          this.dataList = res.list;
          this.params.total = res.total;
        } else {
          this.dataList = [];
        }
        // console.log("this.dataList:", this.dataList)
      });
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "YZFWS_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    onClickDetail(val) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: val.uuid,
          type: "provider",
          titleName: "直播列表",
          titleForm: "providerDetail"
        }
      });
      window.open(routeData.href, "_blank");
    },
    onClickLookMore() {},
    onClickSort(val) {
      this.params.current = 1;
      this.params.stage = val.title;
      //  this.getDataList()
    },
    onChangeCurrent(e) {
      this.params.current = e;
      this.getServiceList();
    }
  }
};
</script>
<style scoped lang="less">
@basic-colors: #2d50a1;

.gov-course-list {
  background: rgb(245 245 245);
  // background: #ffffff;

  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .top-banner-box {
    // background-color: #f7f8fb;
    position: relative;
    top: -80px;
    margin-bottom: -80px;

    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-banner-center {
        width: 1300px;
        height: 500px;
        position: relative;
      }

      .banner-btn {
        width: 130px;
        margin-left: 30px;
        // background-color: white;
        color: transparent;
        letter-spacing: 2px;
        text-align: center;
        padding: 12px 0;
        border-radius: 7px;
        cursor: pointer;
        user-select: none;
        position: absolute;
        bottom: 77px;
        transition: all 0.2s;
      }
    }
  }

  .top-header-box {
    .top-header-img {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      // background-image: url("../../assets/publicService/resourcePool/24.png");
      height: 100px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-search {
        width: 900px;
        border-radius: 24px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #efefef;

        .top-search-icon {
          width: 30px;
          height: 30px;
          background: url("../../assets/publicService/search.png") no-repeat
            center center/25px 26px;
        }

        /* 搜索框样式 */
        /deep/ .el-input-group--append .el-input__inner {
          height: 48px;
          border-top-left-radius: 24px;
          border-bottom-left-radius: 24px;
          border: none;
        }

        /* 搜索图标样式 */
        /deep/ .el-input-group__append {
          padding: 0 12px;
          background-color: #fff;
          border-top-right-radius: 24px;
          border-bottom-right-radius: 24px;
          border: none;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  .breadcrumb {
    width: 1200px;
    margin: 0 auto;
    background: #ffffff;
    margin-top: 10px;
    border-bottom: 1px solid #ccc;
  }

  .key-words {
    font-size: 16px;
    background: #ffffff;
    border-radius: 12px;
    // box-shadow: 0 0 26px 0 #dce2ee;
    overflow: hidden;
    width: 1300px;
    margin: 0px auto 20px;

    .half-radius {
      background-color: #4747f5;
      height: 10px;
      width: 100px;
      margin-top: -3px;
      margin-left: 49px;
      border-radius: 5px;
    }

    .type-wrap {
      .type {
        flex: 1;
        display: flex;
        flex-flow: row nowrap;
        padding-right: 100px;
      }
    }

    .type-wrap1 {
      padding-top: 20px;
      padding-bottom: 10px;
    }

    .type-wrap2 {
      padding-bottom: 20px;
    }

    .words-width {
      margin-left: 15px;
      margin-bottom: 5px;
      padding: 2px 5px;
      cursor: pointer;
      min-width: 40px;
      height: 22px;
      line-height: 22px;
      text-align: center;
    }

    .childTypeList {
      font-size: 14px;
      display: flex;
      height: 45px;
      width: 1100px;
      margin-left: 100px;
      margin-bottom: 20px;
      background-color: #f9f9f9;
      align-items: center;
      .mr0 {
        margin-bottom: 0;
      }
    }

    .cur {
      color: #fff;
      background-color: #2646a4;
      border-radius: 4px;
    }

    .sort-rules-com {
      margin-left: 15px;
      padding: 2px 5px;
      text-align: center;
      cursor: pointer;
      min-width: 40px;
      height: 22px;
      line-height: 22px;
      text-align: center;
    }

    .sort-rules-normal {
      &:hover {
        cursor: pointer;
      }
    }

    .sort-rules-select {
      background: #2d50a1;

      &:hover {
        cursor: pointer;
      }
    }

    /deep/.btn-box > .el-button--small {
      padding: 4px 15px;
      font-size: 12px;
      border-radius: 3px;
    }

    /deep/ .jiage-box > .el-input__inner {
      height: 23px;
    }
  }

  .container {
    width: 1300px;
    margin: 0 auto;
    margin-top: 10px;

    .gov-course {
      margin-top: 20px;
      min-height: 300px;
      position: relative;

      .item-out-box {
        width: 95%;
        height: 275px;
        // box-shadow: 0 0 21px #b7afaf;
        background-color: #fff;
        border: 1px solid #efefef;
        border-radius: 12px;
        cursor: pointer;
        margin-bottom: 15px;

        .pic-out-box {
          margin: 0 auto;
          height: 170px;
          width: 100%;

          .course-list-img {
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-bottom: 0px !important;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            transition: all 0.3s;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
            padding-top: 56.25%;
            width: 100%;
            height: 0;
          }
        }

        .content-title {
          padding-top: 10px;
          padding-bottom: 10px;
          text-align: center;
          font-size: 16px;
          font-weight: 900;

          &:hover {
            color: #2d50a1;
            // font-size: 17px;
          }
        }

        .content-cases {
          width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-left: 45px;
          font-size: 14px;
          padding-top: 5px;
          padding-bottom: 5px;
          color: #918484;
        }

        .content-link-method {
          width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-left: 45px;
          font-size: 14px;
          padding-top: 5px;
          padding-bottom: 5px;
          color: #918484;
        }
      }
    }

    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #2d50a1;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/providerList.vue